import { render, staticRenderFns } from "./ResearchInstructor.vue?vue&type=template&id=7e30af7e&"
import script from "./ResearchInstructor.vue?vue&type=script&lang=js&"
export * from "./ResearchInstructor.vue?vue&type=script&lang=js&"
import style0 from "./ResearchInstructor.vue?vue&type=style&index=0&id=7e30af7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports